export const MAIN_ROUTE: string = '/';
export const LOGIN_ROUTE: string = '/login';
export const REGISTER_ROUTE: string = '/register';
export const ACCOUNT_ROUTE: string = '/account';
export const MORTGAGE_ROUTE: string = '/mortgage';